export default __webpack_public_path__ + "AngloCandidatosUpload_recrutamento.xlsx";